import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import { observer } from 'mobx-react';
import { format, subDays } from 'date-fns';

import { CounterStore } from 'DataSource/Stores/CounterStore';

import { Header } from 'Components/Header';
import { DateFilter } from 'Components/DateFilter';

import { Block } from 'Wrappers/Block';
import { Filled } from 'Wrappers/Filled';
import { Row } from 'Wrappers/Row';

import { Title } from 'Elements/Title';
import { ButtonEdit } from 'Elements/ButtonEdit';
import { ButtonBack } from 'Elements/ButtonBack';
import { ButtonRefresh } from 'Elements/ButtonRefresh';
import { Loader } from 'Elements/Loader';

import { CounterInfo } from 'Blocks/CounterInfo';
import { BlockEditCounter } from './BlockEditCounter';
import { BlockStat } from 'Blocks/BlockStat';

import { StatStoreClass } from 'DataSource/Stores/StatStore';

const CounterDetailsPage = (props) => {

    const [ editCounterMode, stateSetEditCounterMode ] = useState(false);
    const [ startDate, stateSetStartDate ] = useState( subDays(new Date(), 7) );
    const [ endDate, stateSetEndDate ] = useState( new Date() );
    const [ StatStoreDate ] = useState(new StatStoreClass());
    const [ StatStoreOs ] = useState(new StatStoreClass());
    const [ StatStoreIsp ] = useState(new StatStoreClass());
    const [ StatStoreRegion ] = useState(new StatStoreClass());

    const counterId = useParams().id;

    const onRefresh = (withStatistics) => {
        CounterStore.forCounter(counterId);
        withStatistics && loadStatistics();
        return true;
    };

    var statParams = {
        type: 'counter',
        id: counterId,
        startDate: format(startDate, 'yyyy-MM-dd'),
        endDate: format(endDate, 'yyyy-MM-dd'),
    };

    const loadStatistics = () => {

        StatStoreDate.load('/api/statistics/daily', statParams);
        StatStoreOs.load('/api/statistics/os', statParams);
        StatStoreIsp.load('/api/statistics/isp', statParams);
        StatStoreRegion.load('/api/statistics/region', statParams);

    }

    /**
     *
     */
    useEffect(
        () => {
            console.log('Counter details page init');
            onRefresh();
        },
        []
    );

    /**
     *
     */
    useEffect(
        () => {
            console.log('reload statistics');
            loadStatistics()
        },
        [startDate, endDate]
    );

    const pageContent = () => {

        if ( ! CounterStore.data || ! CounterStore.data.length ) {
            return <Loader height="40px" />;
        }

        const counter = CounterStore.data[0];

        return (
            <>
                <FadeIn>
                    <Block>
                        <Filled>
                            <Title>
                                { counter.title }
                            </Title>
                            <ButtonEdit onClick={stateSetEditCounterMode} title="Edit counter" />
                            <ButtonRefresh onClick={() => onRefresh(true)} title="Refresh" />
                            <ButtonBack link={"/campaigns/" + counter['campaign_id']} title="Back to campaign" />
                        </Filled>
                    </Block>
                </FadeIn>

                <FadeIn>
                    <Block>
                        <Filled>
                            <Title>
                                Information
                            </Title>

                        </Filled>

                        <CounterInfo title={counter.title} tail={counter.tail} />

                    </Block>
                </FadeIn>

                {editCounterMode &&
                <FadeIn>
                    <BlockEditCounter
                        setEditMode={stateSetEditCounterMode}
                        counterData={counter}
                        refresh={onRefresh}
                    />
                </FadeIn>
                }

                <FadeIn>
                    <Block>
                        <Row>
                            <DateFilter
                                title='Statistics'
                                dateFrom={startDate}
                                setDateFrom={stateSetStartDate}
                                dateTo={endDate}
                                setDateTo={stateSetEndDate}
                            />
                        </Row>
                    </Block>
                </FadeIn>

                <FadeIn>
                    <BlockStat
                        firstColumnTitle='Date'
                        store={StatStoreDate}
                    />
                </FadeIn>

                <FadeIn>
                    <BlockStat
                        firstColumnTitle='OS'
                        store={StatStoreOs}
                    />
                </FadeIn>

                <FadeIn>
                    <BlockStat
                        firstColumnTitle='ISP'
                        store={StatStoreIsp}
                    />
                </FadeIn>

                <FadeIn>
                    <BlockStat
                        firstColumnTitle='Region'
                        store={StatStoreRegion}
                    />
                </FadeIn>

            </>
        );
    };

    /**
     *
     */
    return (
        <>
            <FadeIn>
                <Block>
                    <Header />
                </Block>
            </FadeIn>

            { pageContent() }

        </>
    );
};

const CounterDetailsPageObserver = observer(CounterDetailsPage);

export { CounterDetailsPageObserver as CounterDetailsPage }
